module.exports = __webpack_public_path__ + "img/battery-1.dc906b4b.svg";